// Deterministic starfield — uses trig pseudo-randomness so stars are
// stable across renders without needing useMemo/useRef.
export const STARS = Array.from({ length: 220 }, (_, i) => ({
  id: i,
  x: ((Math.sin(i * 137.508) + 1) / 2) * 100,
  y: ((Math.cos(i * 251.327) + 1) / 2) * 100,
  r: ((Math.sin(i * 31.41) + 1) / 2) * 1.8 + 0.25,
  opacity: ((Math.cos(i * 47.12) + 1) / 2) * 0.55 + 0.2,
  twinkle: i % 5 === 0,
  delay: `${(i % 30) * 0.1}s`,
  duration: `${1.5 + (i % 10) * 0.2}s`,
}));
